import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERBODYCALLTOACTIONBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "url_button",
  "label_button",
  "button-size-y"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterBodyCallToActionBlockDescriptor: _generatedBigFooterBodyCallToActionBlockDescriptor,
  bigFooterBodyCallToActionBlockBlocDefinition,
  bigFooterBodyCallToActionBlockDashboardLayout,
  bigFooterBodyCallToActionBlockConfig,
  bigFooterBodyCallToActionBlockResolveConfig,
  bigFooterBodyCallToActionBlockProperties,
} = doodBlockConfig(
  {
    name: "Big footer - Body - Call to action",
    componentType: 'BigFooterBodyCallToActionBlockComponent',
    category: 'footer',
    description: "Big footer - Body - Call to action.",
    keywords: [],
    allowedIn: [
      { bloc: "BigFooterBlockComponent", slot: "left_body" },
      { bloc: "BigFooterColumnBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-call-to-action.title.label",
      }
    }),
    url_button: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-call-to-action.url-button.label",
      }
    }),
    label_button: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-body-call-to-action.label-button.label",
      }
    }),
    "button-size-y": propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.big-footer-body-call-to-action.button-size-y.label",
        multiple: false,
        choices: [
          {
            value: "S",
            label: "pages.blocks.big-footer-body-call-to-action.button-size-y.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.big-footer-body-call-to-action.button-size-y.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.big-footer-body-call-to-action.button-size-y.options.L",
          }
        ]
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer-body-call-to-action.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer-body-call-to-action.fieldset.title.label",
            fields: ["title"],
          },
          {
            legend: "pages.blocks.big-footer-body-call-to-action.fieldset.button.label",
            fields: ["label_button", "url_button", "button-size-y"],
          },
        ],
      },
    ],
  })
);

export function bigFooterBodyCallToActionBlockDescriptor(): IBlockDescriptor;
export function bigFooterBodyCallToActionBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterBodyCallToActionBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterBodyCallToActionBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterBodyCallToActionBlockDescriptor, bigFooterBodyCallToActionBlockProperties, fieldOrder);
}

export {
  bigFooterBodyCallToActionBlockBlocDefinition,
  bigFooterBodyCallToActionBlockDashboardLayout,
  bigFooterBodyCallToActionBlockProperties,
  bigFooterBodyCallToActionBlockConfig,
  bigFooterBodyCallToActionBlockResolveConfig,
};

export type BigFooterBodyCallToActionBlockConfig = typeof bigFooterBodyCallToActionBlockConfig;
